export default __webpack_public_path__ + "static/media/EEECFA61-00.7d768993.png";